import React from 'react';
import styled from 'styled-components';
import { getContrast } from 'polished';
import ProgressBar from '../ProgressBar';
import { MAX_ESTIMATION } from '../../constants';
import Button from '../Button';
import { box } from '../../styles/helpers';

export const STATES = {
  ICON: 'icon',
  LEVEL: 'level',
  PROGRESS: 'progress',
  DOMAIN: 'domain',
};
const {
  ICON, LEVEL, PROGRESS, DOMAIN,
} = STATES;

// on some backgrounds white text was hardly legible, this provides a more contrasting color
const textColor = background => background && (getContrast(background, '#FFF') < 2 ? '#000' : '#FFF');

const Wrapper = styled(Button)`
  display: flex;
  align-items: center;

  background-color: ${p => (p.disabled ? '#EEE' : p.background)};
  opacity: ${p => (p.disabled ? 0.5 : 1)};

  overflow: hidden;

  h3 {
    text-transform: uppercase;
    margin: 0;
    font-size: 0.8rem;
  }

  h4 {
    color: ${p => textColor(p.background)};
    font-weight: 100;
    width: 60px;
    font-size: 0.7rem;
    margin: 0;

    span {
      background-color: ${p => textColor(p.background)};
      color: ${p => p.background};
      border-radius: 50%;
      width: 18px;
      line-height: 18px;
      text-align: center;
      display: inline-block;
    }
  }

  h5 {
    color: ${p => textColor(p.background)};
    font-size: 0.7rem;
    line-height: 20px;
    font-weight: 100;
    white-space: nowrap;
    margin: 0;
  }

  ${p => p.theme.breakpoints.smallHeight} {
    h3 {
      font-size: 1rem;
    }

    h4 {
      font-size: 0.8rem;

      span {
        width: 20px;
        line-height: 20px;
      }
    }

    h5 {
      line-height: 25px;
    }
  }
  ${p => p.theme.breakpoints.largeHeight} {
    h3 {
      font-size: 1.1rem;
    }
    h4 {
      font-size: 1rem;
      line-height: 25px;

      span {
        width: 25px;
        line-height: 25px;
      }
    }
  }
`;

const Image = styled.div`
  background-size: cover;
  background-image: url(${p => p.theme.staticDir + p.src});
  width: 40px;
  height: 40px;
  flex: 40px 0 0;

  ${p => p.theme.breakpoints.smallHeight} {
    width: 50px;
    height: 50px;
    flex: 50px 0 0;
  }
  ${p => p.theme.breakpoints.mediumHeight} {
    width: 54px;
    height: 54px;
    flex: 54px 0 0;
  }
  ${p => p.theme.breakpoints.largeHeight} {
    width: 64px;
    height: 64px;
    flex: 64px 0 0;
  }
`;

const LevelDOMAIN = styled.div`
  padding-right: 15px;
`;

const Locked = styled.div`
  width: 40px;
  height: 40px;
  display: flex;

  ${p => box({ ...p, type: 'lockedButton' })}

  ${p => p.theme.breakpoints.smallHeight} {
    width: 50px;
    height: 50px;
  }
  ${p => p.theme.breakpoints.mediumHeight} {
    width: 54px;
    height: 54px;
  }
  ${p => p.theme.breakpoints.largeHeight} {
    width: 64px;
    height: 64px;
  }
`;

function HeroAvatar({
  className,
  color,
  name = '',
  level,
  estimation,
  state = ICON,
  unlocked,
  onClick,
  disabled = false,
  // estimation,
  domain = {},
  children,
}) {
  return unlocked ? (
    <Wrapper className={className} background={color} onClick={onClick} disabled={disabled}>
      <Image src={`assets/game/ui/heroes/${name.toLowerCase()}.png`} />

      {state !== ICON && (
        <LevelDOMAIN>
          <h3>{name}</h3>
          {state === LEVEL && (
            <h4>
              LV
              {' '}
              <span>{level}</span>
            </h4>
          )}
          {state === PROGRESS && <ProgressBar progress={estimation / MAX_ESTIMATION} />}
          {state === DOMAIN && <h5>{domain.title}</h5>}
        </LevelDOMAIN>
      )}
      {children}
    </Wrapper>
  ) : (
    <Locked />
  );
}

export default styled(HeroAvatar)``;
